export default "/_next/static/chunks/fonts/Rubik-Regular-37a4d906e92edcd9484c83065d6a1838.ttf";